import React from "react";
import get from "lodash/get";
import assign from "lodash/assign";
import {
  Tabs,
  Tab,
  CircularProgress,
  RaisedButton,
  FlatButton,
  TextField,
  Checkbox,
  IconButton,
  RadioButtonGroup,
  RadioButton
} from "material-ui";
import Select from "react-select";
import { Link } from "react-router";
import CopyIcon from "material-ui/svg-icons/content/content-copy";

import { snakeCase, formatPrice, capitalize } from "../util";
import config from "../config";

import InfoNotice from "./partials/info-notice.jsx";

import BackButton from "./partials/back-button.jsx";
import WorkingIndicator from "./partials/working-indicator.jsx";

import Label from "./partials/label.jsx";
import DateTimeField from "./partials/datetime-field.jsx";
import CurrencyField from "./partials/currency-field.jsx";
import DurationField from "./partials/duration-field.jsx";
import RecurrenceField from "./partials/recurrence-field.jsx";
import BasicHtmlField from "./partials/basic-html-field.jsx";
import PassRulesEditor from "./partials/pass-rules-editor.jsx";
import SupplementaryDataEditor from "./partials/supplementary-data-editor.jsx";
import QuantityEditor from "./partials/quantity-editor.jsx";
import LinkLike from "./partials/link-like.jsx";
import InlineNoticeLabel from "./partials/inline-notice-label.jsx";

import connectToStores from "alt-utils/lib/connectToStores";
import PassBucketActions from "../actions/PassBucketActions";
import PassBucketStore from "../stores/PassBucketStore";
import EventBucketStore from "../stores/EventBucketStore";
import UserStore from "../stores/UserStore";

import EventivalBanner from "./partials/eventival-banner.jsx";

class PassBucketEditor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      passBucket: {},
      tab: "core",
      dirty: false,
      isSaving: false,
      lastUpdatedAt: false,
      hasEditedCode: false,
      showTermsEditor: false,
      showPriceBreakEditor: false,
      showSalePriceEditor: false,
      showAdvancedSettings: false,
      showMaxQuantityEditor: false,
      values: {}
    };

    this.onChangeValue = this.onChangeValue.bind(this);
    this.onChangeTab = this.onChangeTab.bind(this);
    this.save = this.save.bind(this);
    this.delete = this.delete.bind(this);
    this._makeDirectSalesLink = this._makeDirectSalesLink.bind(this);
    this._makeCoreEditor = this._makeCoreEditor.bind(this);
    this._makeMessagesEditor = this._makeMessagesEditor.bind(this);
    this.duplicate = this.duplicate.bind(this);
    this.migrateToMembership = this.migrateToMembership.bind(this)
  }

  static getStores() {
    return [PassBucketStore, EventBucketStore];
  }

  static getPropsFromStores() {
    return {
      getPassBucketById: PassBucketStore.getPassBucketById,
      getEventBucketById: EventBucketStore.getEventBucketById
    };
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object
    };
  }

  getStyles() {
    return {
      actions: {
        marginTop: 20
      },
      editor: {
        marginTop: 60,
        paddingTop: 40,
        borderTop: "1px solid rgb(224, 224, 224)"
      },
      dropzone: {
        width: 200,
        padding: 20,
        border: "1px dashed #ccc",
        marginBottom: 40,
        cursor: "pointer"
      },
      progress: {
        marginBottom: 50
      },
      h3: {
        margin: "15px 0 10px"
      },
      h2: {
        margin: "30px 0 0"
      }
    };
  }

  onChangeTab(tab) {
    if (typeof tab !== "string") {
      return;
    } // propagation's a bitch
    this.context.router.replace(
      `/event_buckets/${this.props.params.eventBucketId}/${this.props.location.pathname.includes('membership') ? "memberships" : "pass_buckets"}/${this.props.params.passBucketId}/edit` +
      (tab === "core" ? "" : `/${tab}`)
    );
  }

  onChangeValue(id, value) {
    this.state.dirty = true;
    this.state.values[id] = value;
    this.setState(this.state);
  }

  save() {
    var values = assign({}, this.state.values);
    this.setState({
      isSaving: true,
      lastUpdatedAt: this.state.passBucket.updated_at
    });
    PassBucketActions.edit.defer(this.props.params.passBucketId, values);
  }

  migrateToMembership() {
    if (
      window.confirm(
        `Are you sure you want to convert the pass bucket "${this.state.passBucket.name}" to a membership?`
      )
    ) {
      const newValues = assign({}, this.state.values, { is_membership: true })
      this.setState({ dirty: true, values: newValues }, async () => {
        await this.save();
        this.setState({ dirty: false }, () => {
          this.context.router.push(
            `/event_buckets/${this.props.params.eventBucketId}/memberships/${this.props.params.passBucketId}`
          )
        })
      })
    }
  }

  delete() {
    let bucket = this.state.passBucket.event_bucket;
    const isMembership = this.props.location.pathname.includes('membership')
    if (
      window.confirm(
        `Are you sure? This could potentially be very bad and result in angry ${isMembership ? "members" : "passholders"}.`
      )
    ) {
      PassBucketActions.delete(this.props.params.passBucketId);
      this.context.router.push(`/event_buckets/${bucket}/${isMembership ? "memberships" : "pass_buckets"}`);
    }
  }

  _makeDirectSalesLink() {
    let eventBucket = this.props.getEventBucketById(
      this.props.params.eventBucketId
    ),
      passBucket = this.props.getPassBucketById(this.props.params.passBucketId);

    return (
      eventBucket &&
      passBucket &&
      `${passBucket.is_membership ? `${eventBucket.urls.root}memberships/buy` : eventBucket.urls.buy_passes}/${this.state.values.code || "<code-goes-here>"
      }`
    );
  }

  duplicate() {
    if (
      window.confirm(
        `Are you sure you want to duplicate "${this.state.passBucket.name}"?`
      )
    ) {
      PassBucketActions.duplicate(this.props.params.passBucketId);
      this.context.router.push(
        `/event_buckets/${this.props.params.eventBucketId}/${this.props.location.pathname.includes('membership') ? "memberships" : "pass_buckets"}/new?duplicate=true`
      );
    }
  }

  componentDidMount() {
    this.context.router.setRouteLeaveHook(this.props.route, () => {
      if (this.state.dirty) {
        return `Are you sure you wish to leave the ${this.props.location.pathname.includes('membership') ? "membership bucket" : "pass bucket"} editor? Your changes will not be saved.`;
      }
    });

    this.componentWillReceiveProps(this.props);
  }

  componentWillReceiveProps(newProps) {
    var passBucket = newProps.getPassBucketById(newProps.params.passBucketId);

    if (!this.state.isFetchingPassBucket && !passBucket) {
      PassBucketActions.fetchOne(newProps.params.passBucketId);
      this.setState({ isFetchingPassBucket: true });
    } else if (passBucket) {
      this.setState({ isFetchingPassBucket: false });
    }

    const isSuppDataUpdated =
      this.state.passBucket && this.state.passBucket.supplementary_data
        ? this.state.passBucket.supplementary_data.length !==
        passBucket.supplementary_data.length
        : false;

    if (
      Object.keys(this.state.values).length === 0 ||
      this.state.passBucket.id !== newProps.params.passBucketId ||
      passBucket.updated_at !== this.state.lastUpdatedAt ||
      isSuppDataUpdated
    ) {
      this.setState({
        passBucket,
        dirty: false,
        isSaving: false,
        values: passBucket
          ? {
            name: passBucket.name || "",
            code: passBucket.code || "",
            price: passBucket.price || "",
            sale_price: passBucket.sale_price || "",
            unlimited: passBucket.unlimited || false,
            quantity: passBucket.quantity,
            max_quantity_per_person: passBucket.max_quantity_per_person,
            cancellation_allowed: passBucket.cancellation_allowed,
            cancellation_window: passBucket.cancellation_window,
            ticket_transfer_allowed: passBucket.ticket_transfer_allowed,
            gift_allowed: passBucket.gift_allowed,
            volume_price_enabled: passBucket.volume_price_enabled || false,
            volume_price: passBucket.volume_price || [],
            multicurrency_price_enabled:
              passBucket.multicurrency_price_enabled || false,
            multicurrency_price: passBucket.multicurrency_price || [],
            sales_disabled_unless_coupon:
              passBucket.sales_disabled_unless_coupon || false,
            sales_disabled_unless_pass_rule:
              passBucket.sales_disabled_unless_pass_rule || false,
            order_message: passBucket.order_message,
            tickets_enabled: passBucket.tickets_enabled,
            visible_in_box_office: passBucket.visible_in_box_office,
            hide_barcode_from_users: passBucket.hide_barcode_from_users,
            payment_method_required_before_purchase:
              passBucket.payment_method_required_before_purchase,
            tickets_disabled_error_message:
              passBucket.tickets_disabled_error_message,
            confirmation_email_message: passBucket.confirmation_email_message,
            supplementary_data_required_before_purchase:
              passBucket.supplementary_data_required_before_purchase || false,
            custom_renewal_warning_email_message:
              passBucket.custom_renewal_warning_email_message,
            early_warning_email_interval:
              passBucket.early_warning_email_interval,
            terms_at_checkout: passBucket.terms_at_checkout,
            recurrence_enabled: passBucket.recurrence_enabled,
            recurrence_interval: passBucket.recurrence_interval || "year",
            recurrence_count: passBucket.recurrence_count || 1,
            recurrence_fixed_renewal_date:
              passBucket.recurrence_fixed_renewal_date,
            recurrence_renewal_price: passBucket.recurrence_renewal_price,
            block_physical_scan_until_checked_in:
              passBucket.block_physical_scan_until_checked_in,
            passholder_ticket_required: passBucket.passholder_ticket_required,
            is_membership: passBucket.is_membership,
          }
          : {}
      });
    }

    var eventBucket = newProps.getEventBucketById(
      newProps.params.eventBucketId
    );
    if (eventBucket) {
      this.setState({
        passSalesUrl: eventBucket.urls.buy_passes,
        termForPasses: eventBucket.frontend_config.display_passes
      });
    }

    // Set tab; default to "core"
    this.setState({ tab: newProps.params.tab || "core" });
  }

  _makeCoreEditor() {
    let styles = this.getStyles();
    let directSalesLink = this._makeDirectSalesLink();

    const isMembership = this.props.location.pathname.includes('membership');

    const eventBucket = this.props.getEventBucketById(
      this.props.params.eventBucketId
    );
    const userCurrency = (UserStore.getUser() || { currency: "usd" }).currency;
    const offerMulticurrency =
      eventBucket &&
      eventBucket.frontend_config.virtual_festival_show_pass_sales;

    const offerQuantityRestrictionPerPerson =
      eventBucket &&
      (eventBucket.frontend_config.sundance_login ||
        eventBucket.frontend_config
          .enable_pass_quantity_restriction_per_person);

    if (!this.state.passBucket) {
      return <WorkingIndicator fullPage={true} />;
    }

    const MigrateMemberships = () => {
      // Migrate Pass Bucket to Membership
      //
      // Show button only if Memberships are enabled in Event Bucket.
      // Enable button only if 1. there are no pending changes and 2. recurrence is enabled.

      if (eventBucket.frontend_config.memberships_enabled && !this.state.values.is_membership) {
        const notReadyToMigrate = (
          this.state.dirty ||                                  // There are changes pending
          !this.state.values.recurrence_enabled ||             // Recurrence is not enabled
          this.state.values.recurrence_fixed_renewal_date      // Fixed Renewal Date is set
        ) ? true : false

        let promptMessage = '* '
        if (this.state.dirty) { promptMessage += "Pending changes must be saved. " }
        if (!this.state.values.recurrence_enabled) { promptMessage += "Recurrence must be enabled. " }
        if (this.state.values.recurrence_fixed_renewal_date) { promptMessage += "Fixed Renewal prevents the ability to migrate. " }

        return (
          <div style={{ marginTop: 15, marginBottom: 10 }}>
            <RaisedButton label={"Migrate Pass Bucket to Membership"}
              disabled={notReadyToMigrate}
              onTouchTap={this.migrateToMembership}
            />
            {notReadyToMigrate ? (
              <div>
                <em>{promptMessage}</em>
              </div>
            ) : null}
          </div>
        )
      } else return null
    }

    return (
      <div>
        <p style={{ marginBottom: 0 }}>
          Edit general {isMembership ? "membership" : "pass bucket"} settings.
          <InfoNotice style={{ marginTop: 5 }}>
            Check out our{" "}
            <a
              href="http://help.eventive.org/passes/create-pass-buckets"
              target="_blank"
            >
              guide to creating {isMembership ? "memberships" : "pass buckets"}
            </a>
            .
          </InfoNotice>
        </p>
        <div style={{ maxWidth: 517 }}>
          <div>
            <TextField
              value={get(this.state, "values.name", "")}
              floatingLabelText="Name"
              onChange={e => {
                this.onChangeValue("name", e.target.value);
                if (!this.state.hasEditedCode) {
                  // Automatically generate a url code if they haven't entered one
                  this.onChangeValue("code", snakeCase(e.target.value));
                }
              }}
            />
          </div>
          <div>
            <TextField
              value={get(this.state, "values.code", "")}
              floatingLabelText="URL code"
              floatingLabelFixed={true}
              onChange={e => {
                this.state.hasEditedCode = true;
                this.onChangeValue("code", e.target.value);
              }}
            />
            <div>
              Displayed in the URL to the {isMembership ? "membership sales" : "pass sales"}, i.e.
              <br />
              <span style={{ fontStyle: "italic" }}>{directSalesLink}</span>.
            </div>
          </div>
          <div>
            <CurrencyField
              value={get(this.state, "values.price", "")}
              floatingLabelText="Price"
              floatingLabelFixed={true}
              placeholder="$0.00"
              // disabled={
              //   this.state.passBucket &&
              //   this.state.passBucket.recurrence_interval
              // }
              onChange={e => this.onChangeValue("price", e.target.value)}
            />
            {/* {this.state.passBucket &&
            this.state.passBucket.recurrence_interval ? (
              <div>
                Recurrence has been enabled for this pass. The price cannot
                modified.
              </div>
            ) : null} */}
          </div>
          <h3 style={styles.h3}>Quantity</h3>
          {this.state.passBucket.quantity_sold ? (
            <div style={{ marginTop: -10 }}>
              {this.state.passBucket.quantity_sold} {isMembership ? "memberships" : "passes"} sold currently
            </div>)
            : null}
          <div style={{ marginTop: 10 }}>
            <Checkbox
              label="Unlimited quantity for sale"
              checked={get(this.state, "values.unlimited", false)}
              onCheck={(e, checked) =>
                this.onChangeValue("unlimited", !this.state.values.unlimited)
              }
            />
          </div>
          {!this.state.values.unlimited ? (
            <div>
              <TextField
                value={get(this.state, "values.quantity", "0")}
                floatingLabelText="Quantity available"
                type="number"
                disabled={this.state.values.unlimited}
                onChange={e => this.onChangeValue("quantity", e.target.value)}
              />
            </div>
          ) : null}
          {offerQuantityRestrictionPerPerson ? (
            <div>
              <Checkbox
                label={`Restrict maximum quantity of ${isMembership ? "memberships" : "passes"} purchased per customer`}
                checked={
                  this.state.values.max_quantity_per_person ||
                  this.state.showMaxQuantityEditor
                }
                onCheck={(e, checked) => {
                  this.setState({ showMaxQuantityEditor: checked }, () => {
                    this.onChangeValue(
                      "max_quantity_per_person",
                      checked ? 4 : null
                    );
                  });
                }}
              />
              {this.state.showMaxQuantityEditor ||
                this.state.values.max_quantity_per_person ? (
                <div style={{ margin: "-0.5em 3em 0.5em" }}>
                  <Label>Max quantity per customer</Label>
                  <QuantityEditor
                    style={{ marginTop: -14, marginLeft: -17 }}
                    quantity={this.state.values.max_quantity_per_person}
                    min={1}
                    updateQuantity={q =>
                      this.setState({ showMaxQuantityEditor: true }, () =>
                        this.onChangeValue("max_quantity_per_person", q)
                      )
                    }
                  />
                </div>
              ) : null}
            </div>
          ) : null}
          <h3 style={styles.h3}>Recurrence</h3>
          {!isMembership && (
            <div style={{ marginTop: 10 }}>
              <Checkbox
                label="Recurrence enabled"
                checked={get(this.state, "values.recurrence_enabled", false)}
                onCheck={(e, checked) =>
                  this.onChangeValue(
                    "recurrence_enabled",
                    !this.state.values.recurrence_enabled
                  )
                }
              />
            </div>
          )}
          {this.state.values.recurrence_enabled ? (
            <div>
              <div style={{ marginTop: 10 }}>
                {`${isMembership ? "Members" : "When recurrence is enabled, passholders"} will automatically be
                billed once every recurrence interval until their ${isMembership ? "membership" : "pass"} is
                canceled.`}
                {/* <i>
                  Note: Once recurrence is enabled,{" "}
                  <strong>
                    neither the {isMembership ? "membership" : "pass"} price nor the recurrence interval can be
                    modified again
                  </strong>
                  .
                </i> */}
              </div>
              <RecurrenceField
                value={[
                  this.state.values.recurrence_count,
                  this.state.values.recurrence_interval
                ]}
                label="Renew every"
                // style={
                //   this.state.passBucket &&
                //   this.state.passBucket.recurrence_interval
                //     ? { opacity: 0.5, pointerEvents: "none" }
                //     : {}
                // }
                onChange={([count, interval]) => {
                  this.onChangeValue("recurrence_count", count);
                  this.onChangeValue("recurrence_interval", interval);
                }}
              />
              <div>
                <div style={{ marginTop: 10 }}>
                  <Checkbox
                    label="Enable custom manual renewal price"
                    checked={
                      this.state.values.recurrence_renewal_price ||
                      this.state.showRenewalPriceEditor
                    }
                    onCheck={(e, checked) => {
                      this.setState(
                        {
                          showRenewalPriceEditor: !(
                            this.state.values.recurrence_renewal_price ||
                            this.state.showRenewalPriceEditor
                          )
                        },
                        () =>
                          this.onChangeValue("recurrence_renewal_price", null)
                      );
                    }}
                  />
                </div>
                {this.state.showRenewalPriceEditor ||
                  this.state.values.recurrence_renewal_price ? (
                  <div>
                    <div style={{ marginTop: 10, marginBottom: -10 }}>
                      {`${isMembership ? "Members" : "Passholders"} manually renewing their ${isMembership ? "memberships" : "passes"} in advance of its
                      expiration (via their Subscriptions page) will be offered
                      this discounted price.`}
                    </div>
                    <CurrencyField
                      value={get(
                        this.state,
                        "values.recurrence_renewal_price",
                        ""
                      )}
                      floatingLabelText="Manual renewal price"
                      floatingLabelFixed={true}
                      placeholder="$0.00"
                      onChange={e =>
                        this.onChangeValue(
                          "recurrence_renewal_price",
                          e.target.value
                        )
                      }
                    />
                  </div>
                ) : null}
                <div style={{ marginTop: 10 }}>
                  <Checkbox
                    label="Enable fixed renewal date [advanced, not recommended]"
                    checked={
                      this.state.values.recurrence_fixed_renewal_date ||
                      this.state.showFixedRenewalEditor
                    }
                    onCheck={(e, checked) => {
                      this.setState(
                        {
                          showFixedRenewalEditor: !(
                            this.state.values.recurrence_fixed_renewal_date ||
                            this.state.showFixedRenewalEditor
                          )
                        },
                        () =>
                          this.onChangeValue(
                            "recurrence_fixed_renewal_date",
                            null
                          )
                      );
                    }}
                  />
                </div>
                {this.state.showFixedRenewalEditor ||
                  this.state.values.recurrence_fixed_renewal_date ? (
                  <div>
                    <div style={{ marginTop: 10 }}>
                      {`All ${isMembership ? "memberships" : "passes"} purchased will automatically have the following
                      date set as their renewal date (e.g. for calendar-year
                      subscriptions).`}
                    </div>
                    <DateTimeField
                      label="Recurrence fixed renewal date"
                      value={this.state.values.recurrence_fixed_renewal_date}
                      hideTime={true}
                      onChange={(_, date) =>
                        this.onChangeValue(
                          "recurrence_fixed_renewal_date",
                          date
                        )
                      }
                    />
                  </div>
                ) : null}
              </div>
            </div>
          ) : null}
          <h3 style={styles.h3}>Cancellation</h3>
          <div style={{ marginTop: 10 }}>
            <Checkbox
              label="Ticket cancellation allowed"
              checked={get(this.state, "values.cancellation_allowed", false)}
              onCheck={(e, checked) =>
                this.onChangeValue(
                  "cancellation_allowed",
                  !this.state.values.cancellation_allowed
                )
              }
            />
          </div>
          {this.state.values.cancellation_allowed ? (
            <div>
              <div style={{ marginTop: 10 }}>
                {`When ticket cancellation is enabled, ${isMembership ? "members" : "passholders"} who use their
                passes to redeem free (i.e. 100% off) tickets will be able to
                cancel those orders up to the time you set below before the
                event for which each ticket was purchased.`}
              </div>
              <DurationField
                value={get(this.state, "values.cancellation_window", 0)}
                floatingLabelText={
                  'Cancellation cutoff before event (e.g. "2 hours")'
                }
                floatingLabelStyle={{ width: 400 }}
                onChange={e =>
                  this.onChangeValue("cancellation_window", e.target.value)
                }
              />
            </div>
          ) : null}
          <h3 style={styles.h3}>Ticket transfer</h3>
          <div style={{ marginTop: 10 }}>
            <Checkbox
              label={`Allow ${isMembership ? "members" : "passholders"} to transfer tickets ordered with ${isMembership ? "membership" : "pass"}`}
              checked={this.state.values.ticket_transfer_allowed}
              onCheck={(e, checked) =>
                this.onChangeValue(
                  "ticket_transfer_allowed",
                  !this.state.values.ticket_transfer_allowed
                )
              }
            />
          </div>
          <h3 style={styles.h3}>Quantity price breaks</h3>
          <div style={{ marginTop: 10 }}>
            <Checkbox
              label="Enable quantity-based price breaks"
              checked={this.state.values.volume_price_enabled}
              onCheck={(e, checked) => {
                if (
                  !this.state.values.volume_price_enabled &&
                  this.state.values.volume_price.length === 0
                ) {
                  this.onChangeValue("volume_price", [
                    { minimum_quantity: 2, price: "" }
                  ]);
                }
                this.onChangeValue(
                  "volume_price_enabled",
                  !this.state.values.volume_price_enabled
                );
              }}
            />
          </div>
          {this.state.values.volume_price_enabled ? (
            <div>
              <div style={{ marginTop: 10 }}>
                {`For each desired price break, specify a minimum quantity and the
                new per-${isMembership ? "membership" : "pass"} price.`}
              </div>
              <div style={{ marginTop: 5 }}>
                {this.state.values.volume_price.map(
                  ({ minimum_quantity, price }, i) => {
                    return (
                      <div key={i} style={{ marginTop: -10 }}>
                        <TextField
                          value={minimum_quantity}
                          floatingLabelText="Min qty"
                          floatingLabelFixed={true}
                          type="number"
                          style={{ width: 75 }}
                          onChange={e => {
                            this.state.values.volume_price[i].minimum_quantity =
                              e.target.value;
                            this.onChangeValue(
                              "volume_price",
                              this.state.values.volume_price
                            );
                          }}
                        />
                        <CurrencyField
                          value={price}
                          floatingLabelText={isMembership ? "Membership price" : "Pass price"}
                          floatingLabelFixed={true}
                          placeholder="$0.00"
                          style={{ marginLeft: 7, width: 100 }}
                          onChange={e => {
                            this.state.values.volume_price[i].price =
                              e.target.value;
                            this.onChangeValue(
                              "volume_price",
                              this.state.values.volume_price
                            );
                          }}
                        />
                        {i !== 0 && (
                          <FlatButton
                            style={{ minWidth: 20 }}
                            label="×"
                            onTouchTap={() => {
                              this.state.values.volume_price.splice(i, 1);
                              this.onChangeValue(
                                "volume_price",
                                this.state.values.volume_price
                              );
                            }}
                          />
                        )}
                      </div>
                    );
                  }
                )}
              </div>
              <RaisedButton
                style={{ marginTop: 10 }}
                label="Add another price break"
                onTouchTap={() => {
                  this.onChangeValue(
                    "volume_price",
                    this.state.values.volume_price.concat([{}])
                  );
                }}
              />
            </div>
          ) : null}
          {!isMembership ? (
            <div>
              <h3 style={styles.h3}>Sale price</h3>
              <div style={{ marginTop: 10 }}>
                <Checkbox
                  label="Enable custom sale price"
                  checked={
                    this.state.values.sale_price || this.state.showSalePriceEditor
                  }
                  onCheck={(e, checked) => {
                    this.setState(
                      {
                        showSalePriceEditor: !(
                          this.state.values.sale_price ||
                          this.state.showSalePriceEditor
                        )
                      },
                      () => this.onChangeValue("sale_price", null)
                    );
                  }}
                />
              </div>
              {this.state.showSalePriceEditor || this.state.values.sale_price ? (
                <div>
                  <div style={{ marginTop: 10 }}>
                    Discount will be highlighted as a sale on {isMembership ? "membership" : "pass"} sales page
                    (compared to regular price of{" "}
                    {formatPrice(this.state.values.price, true)} &ndash; editable
                    above).
                  </div>
                  <CurrencyField
                    value={get(this.state, "values.sale_price", "")}
                    floatingLabelText="Sale price"
                    floatingLabelFixed={true}
                    placeholder="$0.00"
                    disabled={
                      this.state.passBucket &&
                      this.state.passBucket.recurrence_interval
                    }
                    onChange={e => this.onChangeValue("sale_price", e.target.value)}
                  />
                </div>
              ) : null}
            </div>
          ) : null}
          {offerMulticurrency ? (
            <div>
              <h3 style={styles.h3}>Virtual catalog multi-currency pricing</h3>
              <div style={{ marginTop: 10 }}>
                <Checkbox
                  label={`Enable multi-currency pricing for virtual catalog sales of this ${isMembership ? "membership" : "pass bucket"}`}
                  checked={this.state.values.multicurrency_price_enabled}
                  onCheck={(e, checked) => {
                    if (
                      !this.state.values.multicurrency_price_enabled &&
                      this.state.values.multicurrency_price.length === 0
                    ) {
                      this.onChangeValue("multicurrency_price", [
                        { currency: "", price: "" }
                      ]);
                    }
                    this.onChangeValue(
                      "multicurrency_price_enabled",
                      !this.state.values.multicurrency_price_enabled
                    );
                  }}
                />
              </div>
              {this.state.values.multicurrency_price_enabled ? (
                <div>
                  <div style={{ marginTop: 10 }}>
                    <strong>Multi-currency pricing</strong>: Add each additional
                    currency that you would like to offer in the virtual
                    catalog. Users will be recommended prices in their local
                    currency, if available. They can also select another
                    currency. Payments will be instantly converted to your
                    default currency ({userCurrency.toUpperCase()}) at the time
                    of sale using Stripe's current mid-market exchange rate.
                  </div>
                  <div style={{ marginTop: 5 }}>
                    {this.state.values.multicurrency_price.map(
                      ({ currency, price }, i) => {
                        return (
                          <div
                            key={i}
                            style={{
                              marginTop: -10,
                              display: "flex",
                              alignItems: "center"
                            }}
                          >
                            <div
                              style={{
                                width: 100,
                                marginRight: 12,
                                marginTop: 1
                              }}
                            >
                              <Label>Currency</Label>
                              <Select
                                style={{ marginTop: -7 }}
                                clearable={false}
                                value={currency}
                                options={config.fee.supported_currencies
                                  .filter(
                                    k =>
                                      k.toLowerCase() !==
                                      userCurrency.toLowerCase()
                                  )
                                  .map(k => ({
                                    label: k.toUpperCase(),
                                    value: k
                                  }))}
                                onChange={v => {
                                  this.state.values.multicurrency_price[
                                    i
                                  ].currency = v.value;
                                  this.onChangeValue(
                                    "multicurrency_price",
                                    this.state.values.multicurrency_price
                                  );
                                }}
                              />
                            </div>
                            <CurrencyField
                              value={price}
                              floatingLabelText={isMembership ? "Membership price" : "Pass price"}
                              floatingLabelFixed={true}
                              placeholder="$0.00"
                              currency={currency}
                              style={{ marginLeft: 7, width: 100 }}
                              onChange={e => {
                                this.state.values.multicurrency_price[i].price =
                                  e.target.value;
                                this.onChangeValue(
                                  "multicurrency_price",
                                  this.state.values.multicurrency_price
                                );
                              }}
                            />
                            {i !== 0 && (
                              <FlatButton
                                style={{ minWidth: 20, marginTop: 20 }}
                                label="×"
                                onClick={() => {
                                  this.state.values.multicurrency_price.splice(
                                    i,
                                    1
                                  );
                                  this.onChangeValue(
                                    "multicurrency_price",
                                    this.state.values.multicurrency_price
                                  );
                                }}
                              />
                            )}
                          </div>
                        );
                      }
                    )}
                  </div>
                  <RaisedButton
                    style={{ marginTop: 15, marginBottom: 5 }}
                    label="Add another currency"
                    onClick={() => {
                      this.onChangeValue(
                        "multicurrency_price",
                        this.state.values.multicurrency_price.concat([{}])
                      );
                    }}
                  />
                </div>
              ) : null}
            </div>
          ) : null}

          <h3 style={styles.h3}>Gift purchases</h3>
          <div style={{ marginTop: 10 }}>
            <Checkbox
              label={`Allow ${isMembership ? "membership" : "pass"} to be purchased as a gift`}
              checked={this.state.values.gift_allowed}
              onCheck={(e, checked) =>
                this.onChangeValue(
                  "gift_allowed",
                  !this.state.values.gift_allowed
                )
              }
            />
          </div>
          <h3 style={styles.h3}>Advance reservations</h3>
          <div>
            <Checkbox
              label="Use default event bucket setting"
              checked={
                this.state.values.passholder_ticket_required === "default"
              }
              onCheck={(e, checked) =>
                this.onChangeValue(
                  "passholder_ticket_required",
                  checked ? "default" : ""
                )
              }
            />
            {this.state.values.passholder_ticket_required !== "default" ? (
              <RadioButtonGroup
                name="passholder_ticket_required"
                valueSelected={(typeof this.state.values
                  .passholder_ticket_required !== "undefined"
                  ? this.state.values.passholder_ticket_required
                  : ""
                ).toString()}
                onChange={(e, v) =>
                  this.onChangeValue("passholder_ticket_required", v)
                }
              >
                <RadioButton
                  value="true"
                  label={
                    `Require ${isMembership ? "member" : "passholder"} ticket reservation in advance ("RSVP required"; overridable on a per-event basis)`
                  }
                  disabled={
                    this.state.values.passholder_ticket_required === "default"
                  }
                />
                <RadioButton
                  value="false"
                  label={`Do not require advance reservation; allow ${isMembership ? "member" : "passholder"} walk-ups`}
                  disabled={
                    this.state.values.passholder_ticket_required === "default"
                  }
                />
              </RadioButtonGroup>
            ) : null}
          </div>

          <h3 style={styles.h3}>Status</h3>
          <div style={{ marginTop: 10 }}>
            <Checkbox
              label={`Enable ticket orders (allow ${isMembership ? "members" : "passholders"} to reserve tickets with ${isMembership ? "membership" : "pass"})`}
              checked={get(this.state, "values.tickets_enabled", false)}
              onCheck={e =>
                this.onChangeValue(
                  "tickets_enabled",
                  !this.state.values.tickets_enabled
                )
              }
            />
          </div>
          <h3 style={styles.h3}>Advanced</h3>
          <div style={{ marginTop: -5 }}>
            <LinkLike
              onTouchTap={() => {
                this.setState({
                  showAdvancedSettings: !this.state.showAdvancedSettings
                });
              }}
            >
              {this.state.showAdvancedSettings
                ? "Hide advanced settings"
                : "Show advanced settings"}
            </LinkLike>
          </div>
          {this.state.showAdvancedSettings ? (
            <div>
              <div style={{ marginTop: 10 }}>
                <Checkbox
                  label="Sales locked: Require a valid discount code in order to purchase"
                  checked={get(
                    this.state,
                    "values.sales_disabled_unless_coupon",
                    false
                  )}
                  onCheck={e =>
                    this.onChangeValue(
                      "sales_disabled_unless_coupon",
                      !this.state.values.sales_disabled_unless_coupon
                    )
                  }
                />
              </div>
              <div style={{ marginTop: 5 }}>
                <Checkbox
                  label={`Sales ${isMembership ? "membership" : "pass"}-locked: Require a valid ${isMembership ? "membership" : "pass"} rule from another ${isMembership ? "membership" : "pass"} in order to buy this ${isMembership ? "membership" : "pass"} (disable standalone sales)`}
                  checked={get(
                    this.state,
                    "values.sales_disabled_unless_pass_rule",
                    false
                  )}
                  onCheck={e =>
                    this.onChangeValue(
                      "sales_disabled_unless_pass_rule",
                      !this.state.values.sales_disabled_unless_pass_rule
                    )
                  }
                />
              </div>
              <div style={{ marginTop: 5 }}>
                <Checkbox
                  label={`Allow users to access scannable barcode from their "My ${isMembership ? "Memberships" : capitalize(
                    this.state.termForPasses || "passes"
                  )}" page`}
                  checked={
                    !get(this.state, "values.hide_barcode_from_users", false)
                  }
                  onCheck={e =>
                    this.onChangeValue(
                      "hide_barcode_from_users",
                      !this.state.values.hide_barcode_from_users
                    )
                  }
                />
              </div>
              <div style={{ marginTop: 5 }}>
                <Checkbox
                  label={
                    <span>
                      <i>(Physical events only)</i> Require {isMembership ? "memberships" : "passes"} to be checked
                      in using Eventive Check-In before they can be scanned at
                      physical events
                    </span>
                  }
                  checked={get(
                    this.state,
                    "values.block_physical_scan_until_checked_in",
                    false
                  )}
                  onCheck={e =>
                    this.onChangeValue(
                      "block_physical_scan_until_checked_in",
                      !this.state.values.block_physical_scan_until_checked_in
                    )
                  }
                />
              </div>
              <div style={{ marginTop: 5 }}>
                <Checkbox
                  label="Visible for sale in Box Office"
                  checked={get(
                    this.state,
                    "values.visible_in_box_office",
                    false
                  )}
                  onCheck={e =>
                    this.onChangeValue(
                      "visible_in_box_office",
                      !this.state.values.visible_in_box_office
                    )
                  }
                />
              </div>
              {UserStore.isGod() && !this.state.values.price ? (
                <div style={{ marginTop: 5 }}>
                  <Checkbox
                    label={`[GOD ONLY] Collect payment method for $0 ${isMembership ? "membership" : "pass"} sale (e.g. for rush line)`}
                    checked={get(
                      this.state,
                      "values.payment_method_required_before_purchase",
                      false
                    )}
                    onCheck={e =>
                      this.onChangeValue(
                        "payment_method_required_before_purchase",
                        !this.state.values
                          .payment_method_required_before_purchase
                      )
                    }
                  />
                </div>
              ) : null}
              <MigrateMemberships />
            </div>
          ) : null}
        </div>
        <div style={styles.actions}>
          <RaisedButton
            label={this.state.dirty ? "Save changes" : "No changes to save"}
            primary={true}
            disabled={!this.state.dirty}
            onTouchTap={this.save}
          />
          <RaisedButton
            label={`Delete ${isMembership ? "membership bucket" : "pass bucket"}`}
            onTouchTap={this.delete}
            style={{ marginLeft: 7 }}
          />
        </div>
      </div>
    );
  }

  _makeMessagesEditor() {
    let styles = this.getStyles(),
      showTermsEditor =
        !!this.state.values.terms_at_checkout || this.state.showTermsEditor,
      showConfirmationEmailEditor =
        !!this.state.values.confirmation_email_message ||
        this.state.showConfirmationEmailEditor,
      showEarlyWarningEmailDropdown =
        !!this.state.values.early_warning_email_interval ||
        this.state.showEarlyWarningEmailDropdown,
      showCustomRenewalWarningEditor =
        !!this.state.values.custom_renewal_warning_email_message ||
        this.state.showCustomRenewalWarningEditor;

    const isSupplementaryDataEmptyAndNotActive = (typeof this.state.passBucket === "undefined" || typeof this.state.passBucket.supplementary_data === "undefined" || this.state.passBucket.supplementary_data.length === 0) && !get(
      this.state,
      "values.supplementary_data_required_before_purchase",
      false
    )

    const isMembership = this.props.location.pathname.includes('membership');

    return (
      <div>
        <p style={{ marginBottom: -5 }}>
          Configure messages displayed to users related to this {isMembership ? "membership" : "pass bucket"}.
          <InfoNotice style={{ marginTop: 5 }}>
            Check out our{" "}
            <a
              href="http://help.eventive.org/passes/customize-pass-bucket-messages"
              target="_blank"
            >
              guide to {isMembership ? "membership" : "pass bucket"} messages
            </a>
            .
          </InfoNotice>
        </p>
        <div>
          <h2 style={styles.h2}>Ordering</h2>
          <div style={{ marginTop: 10 }}>
            <Checkbox
              label="Require agreement to a waiver/terms of use before placing order"
              checked={showTermsEditor}
              onCheck={(e, checked) => {
                this.setState({ showTermsEditor: checked }, () => {
                  if (!this.state.showTermsEditor) {
                    this.onChangeValue("terms_at_checkout", "");
                  }
                });
              }}
            />
          </div>
          {showTermsEditor ? (
            <BasicHtmlField
              label="Waiver message to display"
              value={get(this.state, "values.terms_at_checkout", "")}
              onChange={v => this.onChangeValue("terms_at_checkout", v)}
            />
          ) : null}
          <div style={{ marginTop: 10 }}>
            <Checkbox
              label={
                <span>
                  Custom confirmation email message (overrides default set in{" "}
                  <Link
                    to={`/event_buckets/${this.props.params.eventBucketId}/configurator/${isMembership ? "memberships" : "passes"}`}
                  >
                    Configurator
                  </Link>
                  )
                </span>
              }
              checked={showConfirmationEmailEditor}
              onCheck={(e, checked) => {
                this.setState({ showConfirmationEmailEditor: checked }, () => {
                  if (!this.state.showConfirmationEmailEditor) {
                    this.onChangeValue("confirmation_email_message", "");
                  }
                });
              }}
            />
          </div>
          {showConfirmationEmailEditor ? (
            <BasicHtmlField
              label="Confirmation email message"
              value={get(this.state, "values.confirmation_email_message", "")}
              onChange={v =>
                this.onChangeValue("confirmation_email_message", v)
              }
            />
          ) : null}
          <div style={{ marginTop: 10 }}>
            <Checkbox
              label={`Require supplementary data to be completed before purchase${isSupplementaryDataEmptyAndNotActive
                ? " (Please add field(s) in the Supplementary Data tab before activating this feature)"
                : ""
                }`}
              checked={get(
                this.state,
                "values.supplementary_data_required_before_purchase",
                false
              )}
              onCheck={(e, checked) => {
                this.onChangeValue(
                  "supplementary_data_required_before_purchase",
                  !this.state.values.supplementary_data_required_before_purchase
                );
              }}
              disabled={isSupplementaryDataEmptyAndNotActive}
            />
          </div>
        </div>
        <div>
          <h2 style={styles.h2}>Using</h2>
          <div>
            <TextField
              value={get(this.state, "values.order_message", "")}
              floatingLabelText="Order message"
              fullWidth={true}
              onChange={e =>
                this.onChangeValue("order_message", e.target.value)
              }
            />
            <div style={{}}>
              {`When this ${isMembership ? "membership" : "pass bucket"} is enabled for ticket orders, ${isMembership ? "members" : "passholders"}
              will see the above message in the "Order tickets" dropdown.`}
            </div>
            <div style={{ fontSize: "0.85em" }}>
              Available insertables: <strong>{"{{quantity}}"}</strong> = quick order
              quantity, <strong>{"{{tickets}}"}</strong> = either "tickets" or "ticket"
              (quantity-dependent), <strong>{isMembership ? "{{membership}}" : "{{pass}}"}
              </strong> = name on {isMembership ? "membership" : "pass"},{" "}
              <strong>{"{{price}}"}</strong> = adjusted ticket price for {isMembership ? "membership" : "pass"}
            </div>
          </div>
          <div>
            <TextField
              value={get(
                this.state,
                "values.tickets_disabled_error_message",
                0
              )}
              floatingLabelText={"Ticket order error message"}
              fullWidth={true}
              onChange={e =>
                this.onChangeValue(
                  "tickets_disabled_error_message",
                  e.target.value
                )
              }
            />
            <div style={{}}>
              {`When this ${isMembership ? "membership" : "pass bucket"} isn't enabled for ticket orders, ${isMembership ? "members" : "passholders"}
              will see the above error message next to the ${isMembership ? "membership" : "pass"} in the dropdown
              instead.`}
            </div>
          </div>
        </div>
        {get(this.state, "values.recurrence_enabled", "") ? (
          <div>
            <h2 style={styles.h2}>Recurrence</h2>
            <div style={{ marginTop: 10 }}>
              <Checkbox
                label="Send warning email message 7 days before renewal"
                checked={true}
                disabled
              />
            </div>
            <div style={{ marginTop: 10 }}>
              <Checkbox
                label="Send optional early warning email"
                checked={showEarlyWarningEmailDropdown}
                onCheck={(e, checked) => {
                  this.setState(
                    { showEarlyWarningEmailDropdown: checked },
                    () => {
                      if (!this.state.showEarlyWarningEmailDropdown) {
                        this.onChangeValue("early_warning_email_interval", "");
                      }
                    }
                  );
                }}
              />
            </div>
            {showEarlyWarningEmailDropdown ? (
              <div style={{ marginTop: 10, width: 250 }}>
                <div
                  style={{
                    color: "rgba(33, 33, 33, 0.5)",
                    fontSize: 12,
                    paddingBottom: 8
                  }}
                >
                  Early warning email interval
                </div>
                <div style={{ paddingBottom: "5px" }}>
                  <Select
                    multi={false}
                    clearable={false}
                    value={get(
                      this.state.values,
                      "early_warning_email_interval",
                      ""
                    )}
                    options={[
                      { value: 7, label: "14 days before renewal" },
                      { value: 14, label: "21 days before renewal" },
                      { value: 45, label: "52 days before renewal" }
                    ]}
                    onChange={v => {
                      this.onChangeValue(
                        "early_warning_email_interval",
                        v.value
                      );
                    }}
                  />
                </div>
              </div>
            ) : null}
            <div style={{ marginTop: 10 }}>
              <Checkbox
                label="Custom renewal warning email message"
                checked={showCustomRenewalWarningEditor}
                onCheck={(e, checked) => {
                  this.setState(
                    { showCustomRenewalWarningEditor: checked },
                    () => {
                      if (!this.state.showCustomRenewalWarningEditor) {
                        this.onChangeValue(
                          "custom_renewal_warning_email_message",
                          ""
                        );
                      }
                    }
                  );
                }}
              />
            </div>
            {showCustomRenewalWarningEditor ? (
              <BasicHtmlField
                value={get(
                  this.state,
                  "values.custom_renewal_warning_email_message",
                  ""
                )}
                onChange={v =>
                  this.onChangeValue("custom_renewal_warning_email_message", v)
                }
                style={{ paddingTop: 10 }}
              />
            ) : null}
          </div>
        ) : null}
        <div style={styles.actions}>
          <RaisedButton
            label={this.state.dirty ? "Save changes" : "No changes to save"}
            primary={true}
            disabled={!this.state.dirty}
            onTouchTap={this.save}
          />
        </div>
      </div>
    );
  }

  render() {
    const isMembership = this.props.location.pathname.includes('membership');

    return (
      <div>
        <div style={{ position: "relative", paddingTop: 1, paddingBottom: 8 }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center"
            }}
          >
            <BackButton
              label={isMembership ? "memberships" : "pass buckets"}
              onTouchTap={() =>
                this.props.location.state &&
                  this.props.location.state.fromListing
                  ? this.context.router.goBack()
                  : this.context.router.push(
                    `/event_buckets/${this.props.params.eventBucketId}/${isMembership ? "memberships" : "pass_buckets"}`
                  )
              }
            />
            <h2 style={{ flex: 1, textAlign: "center", fontSize: "2em" }}>
              {this.state.values.name || "..."}
            </h2>
            <IconButton
              tooltip={
                this.state.dirty
                  ? "Please save before duplicating"
                  : "Duplicate pass bucket"
              }
              onTouchTap={this.duplicate}
              disabled={this.state.dirty}
            >
              <CopyIcon />
            </IconButton>
          </div>
          {this.state.passBucket && this.state.passBucket.eventival_id && (
            <EventivalBanner
              type="pass bucket"
              style={{ marginTop: 15, marginBottom: 5 }}
            />
          )}
        </div>
        <Tabs
          value={this.state.tab}
          onChange={this.onChangeTab}
          style={{ clear: "both" }}
        >
          {UserStore.hasPermission("edit_pass_bucket") ? (
            <Tab label="General" value="core">
              {this._makeCoreEditor()}
            </Tab>
          ) : null}
          {UserStore.hasPermission("edit_pass_bucket") ? (
            <Tab label="Messages" value="messages">
              {this._makeMessagesEditor()}
            </Tab>
          ) : null}
          {UserStore.hasPermission("edit_pass_bucket") ? (
            <Tab label="Supplementary data" value="supplementary_data">
              <SupplementaryDataEditor
                showHeader={false}
                passBucketId={this.props.params.passBucketId}
                eventBucketId={this.props.params.eventBucketId}
                requiredFieldsToPurchase={get(
                  this.state,
                  "values.supplementary_data_required_before_purchase",
                  false
                )}
                isMembership={isMembership}
              />
            </Tab>
          ) : null}
          {UserStore.hasPermission("edit_pass_bucket") ||
            UserStore.hasPermission("view_pass_bucket_rules") ? (
            <Tab label={isMembership ? "Membership rules" : "Pass rules"} value="pass_rules">
              <PassRulesEditor
                showHeader={false}
                mode="pass_bucket"
                parentId={this.props.params.passBucketId}
                eventBucketId={this.props.params.eventBucketId}
                isMembership={isMembership}
              />
            </Tab>
          ) : null}
        </Tabs>
      </div>
    );
  }
}

export default connectToStores(PassBucketEditor);


// WEBPACK FOOTER //
// ./src/app/components/pass-bucket-editor.jsx